import { useDispatch } from "react-redux";
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { createCita } from "../services/cita.service";

import { successNotification, dangerNotification } from '../../../../redux/slices/ui';

export const useCitaNueva = () => {

    const dispatch = useDispatch();

    const queryClient = useQueryClient();

    const createCitaMutation = useMutation({
        mutationFn: createCita,
        onSuccess: ({ inactivoFlag, horarioFlag, empalmadaFlag, asociadoFlag, cita }, variables, context) => {
            if(inactivoFlag){
                variables.onInactivo();
            }else if(horarioFlag){
                variables.onHorario();
            }else if(empalmadaFlag){
                variables.onEmpalmada();
            }else if(asociadoFlag){
                variables.onAsociado();
            }else{
                if(typeof cita.paciente !== 'undefined' && typeof cita.paciente._id !== 'undefined'){
                    queryClient.invalidateQueries({ queryKey: ['citas', cita.paciente._id] });
                }
                queryClient.invalidateQueries({ queryKey: ['agenda'], exact: false });
                queryClient.invalidateQueries({ queryKey: ['agendaInmunoterapia'], exact: false });
                variables.onComplete();
                variables.onSuccess();
                dispatch(successNotification('Cita creada'));
            }
        },
        onError: (error, variables, context) => {
            variables.onComplete();
            dispatch(dangerNotification(error.message));
            // dispatch(dangerNotification(error.msg.message));
        }
    });

    return {
        createCitaMutation,
    }
}